import React, { useState, useEffect } from "react"
import _ from "lodash"

import { SingleRowCarouselState_s } from "components/table/carousel/carousel-styles"
import { DropdownInput, NumberInput } from "components/table/carousel/inputs"
import { field_attrs } from "components/table/lib/column-field"

const FreeRentBasic = (props: {rowData: [], field: string, defaults: {}, persist: Function}) => {
  const emptyRecord = {
    amtType: null,
    new: null,
    renewal: null,
    revenue: null
  }
  const [data, setData] = useState<object|null>(props.rowData[props.field]);

  useEffect(() => {
    if (!props['rowData'][props.field] || props['rowData'][props.field].state !== 'basic') setData(emptyRecord)
  }, [props['rowData']])

  function updateData(val:any, field:string):void {
    let nextData = _.cloneDeep(data)
    nextData[field] = val
    if (!nextData['amtType']) nextData['amtType'] = props.defaults['freeRentAmtType']
    if (!nextData['revenue']) nextData['revenue'] = props.defaults['freeRentRevenue']
    setData(nextData);
    props.persist({...nextData, state: 'basic'}, 'freerentdetail', props.rowData)
  }

  const attrs = (field) => field_attrs('marketlease', props.field)(field)(props.rowData, props)

  return (
    <div>
      <SingleRowCarouselState_s>
        <div>
          <label>New</label>
          <NumberInput 
            field="new" 
            className="automated" 
            data={data} 
            attrs={attrs} 
            min={0} 
            max={1200} 
            readPrecision={2}
            writePrecision={2}
            persist={updateData} 
          />
        </div>
        <div>
          <label>Renewal</label>
          <NumberInput 
            field="renewal" 
            className="automated" 
            data={data} 
            attrs={attrs} 
            min={0} 
            max={1200} 
            readPrecision={2}
            writePrecision={2}
            persist={updateData} 
          />
        </div>
        <div>
          <label>Amt Type</label>
          <DropdownInput 
            field="amtType" 
            className="automated" 
            data={data} 
            attrs={attrs} 
            default={props.defaults['freeRentAmtType']}
            options={['Mos', 'Mos/Yr']} 
            persist={updateData} 
          />
        </div>
        <div> 
          <label>Revenue</label>
          <DropdownInput 
            field="revenue" 
            className="automated" 
            data={data} 
            attrs={attrs} 
            default={props.defaults['freeRentRevenue']}
            options={['Rent', 'Rent + Recovery', 'All Revenues', 'Recovery']} 
            persist={updateData} 
          />
        </div>
      </SingleRowCarouselState_s>
    </div>
  )
}

export default FreeRentBasic
